export default __webpack_public_path__ + "static/media/835.bf929da7.jpg";